/**
 * Labstep
 *
 * @module screens/OrderRequest/Show/Center
 * @desc OrderRequest Show  Center
 */

import { LayoutContainerActions } from 'labstep-web/components/Layout/Container/Actions';
import { OrderRequestResourceItemCount } from 'labstep-web/components/OrderRequest/ResourceItemCount';
import { OrderRequestStatusLog } from 'labstep-web/components/OrderRequest/Status/Log';
import { ResourceItemActionImport } from 'labstep-web/components/ResourceItem/Action/Import';
import { OrderRequestStatus } from 'labstep-web/models/order-request.model';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import type React from 'react';
import type { IScreensOrderRequestShowCenterBottomProps } from './types';

export const ScreensOrderRequestShowCenterBottom: React.FC<
  IScreensOrderRequestShowCenterBottomProps
> = ({ orderRequest }) => (
  <div>
    <LayoutContainerActions>
      {(orderRequest.status ===
        OrderRequestStatus.partially_received ||
        orderRequest.status === OrderRequestStatus.received) &&
        orderRequest.resource_item_count < orderRequest.quantity && (
          <ResourceItemActionImport
            resource={orderRequest.resource}
            orderRequest={orderRequest}
            actionComponentProps={{
              type: 'button',
              elementProps: { basic: true },
              text: `Add ${ResourceItem.getHumanReadableEntityName(
                true,
                false,
                orderRequest.resource.is_template,
              )} to Inventory`,
            }}
          />
        )}
      <OrderRequestResourceItemCount orderRequest={orderRequest} />
    </LayoutContainerActions>
    <OrderRequestStatusLog orderRequest={orderRequest} />
  </div>
);
